/* Casa di Rosa — aggiunta al carrello + barra sticky.
   Riproduce il flusso di Dawn (POST su cart_add_url con le sections, poi
   renderContents sul <cart-drawer>) senza dipendere da fetchConfig, publish
   o PUB_SUB_EVENTS. Se il cassetto non esiste, si lascia il comportamento
   nativo: il form fa il suo POST, la barra resta un'ancora. */
(function () {
  var r = document.getElementById('cdr-pdp');
  if (!r) return;
  var $ = function (s) { return r.querySelector(s); };

  /* ---------- Galleria ---------- */
  var main = $('#cdr-main');
  r.querySelectorAll('.th button').forEach(function (b) {
    b.addEventListener('click', function () {
      var c = r.querySelector('.th button.on');
      if (c) { c.classList.remove('on'); c.setAttribute('aria-pressed', 'false'); }
      b.classList.add('on'); b.setAttribute('aria-pressed', 'true');
      main.src = b.dataset.src; main.removeAttribute('srcset');
      main.alt = b.querySelector('img').alt;
    });
  });

  /* ---------- Pack: quantita, prezzi, regali sbloccati ---------- */
  var packs = r.querySelectorAll('.pack'), qty = $('#cdr-qty'), pr = $('#cdr-pr'),
      cmp = $('#cdr-cmp'), ctap = $('#cdr-ctap'), bp = $('#cdr-bp'),
      prsub = $('#cdr-prsub'), regali = r.querySelectorAll('.reg-c');
  packs.forEach(function (p) {
    p.addEventListener('click', function () {
      packs.forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-pressed', 'false'); });
      p.classList.add('on'); p.setAttribute('aria-pressed', 'true');
      var d = p.dataset;
      qty.value = d.q;
      pr.textContent = d.pr;
      cmp.textContent = d.cmp || ''; cmp.hidden = !d.cmp;
      /* L'etichetta sotto il prezzo dice a COSA corrisponde la cifra: senza,
         il cliente legge 39,90 davanti alla foto di un solo sacchetto. */
      if (prsub) prsub.textContent = d.sub || '';
      if (ctap) ctap.textContent = d.pr;
      bp.innerHTML = d.pr + (d.cmp ? ' <s>' + d.cmp + '</s>' : '');
      var n = parseInt(d.reg, 10) || 1;
      regali.forEach(function (g) { g.classList.toggle('on', parseInt(g.dataset.n, 10) <= n); });

      /* La foto grande segue il pack scelto: chi clicca "3 sacchetti" vuole
         vedere i tre sacchetti, non restare sull'immagine di prima.
         Si riusa la miniatura della carta, chiesta in 900 px invece di 300. */
      var fp = p.querySelector('.pack-f img');
      if (fp && main) {
        main.src = (fp.currentSrc || fp.src).replace(/width=\d+/, 'width=900');
        main.removeAttribute('srcset');
        main.alt = p.querySelector('.pack-n') ? p.querySelector('.pack-n').textContent : main.alt;
        r.querySelectorAll('.th button.on').forEach(function (b) {
          b.classList.remove('on'); b.setAttribute('aria-pressed', 'false');
        });
      }
    });
  });

  /* ---------- Finestra di spedizione: 1-2 giorni lavorativi ----------
     La lingua viene dal <html lang> che Shopify scrive per ogni mercato:
     de, es, fr, nl, da. Scriverla a mano qui darebbe date in italiano
     anche al cliente tedesco. */
  function lav(n) {
    var d = new Date(), i = 0;
    while (i < n) { d.setDate(d.getDate() + 1); var g = d.getDay(); if (g !== 0 && g !== 6) i++; }
    return d;
  }
  try {
    var lingua = document.documentElement.lang || 'it-IT';
    var fmt = new Intl.DateTimeFormat(lingua, { weekday: 'short', day: 'numeric', month: 'short' });
    $('#cdr-d1').textContent = fmt.format(lav(1));
    $('#cdr-d2').textContent = fmt.format(lav(2));
  } catch (e) {}

  /* ---------- Aggiunta al carrello ---------- */
  var form = $('#cdr-form'), cta = $('#cdr-cta'), barra = $('#cdr-barra');
  var addUrl = (window.routes && routes.cart_add_url) ? routes.cart_add_url : '/cart/add';
  var cartUrl = (window.routes && routes.cart_url) ? routes.cart_url : '/cart';

  function cassetto() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  /* true = gestito qui; false = si lascia il comportamento nativo */
  function aggiungi(btn) {
    var c = cassetto();
    if (!c || !form || typeof c.renderContents !== 'function') return false;

    var fd = new FormData();
    fd.append('id', form.querySelector('[name=id]').value);
    fd.append('quantity', qty.value);
    if (typeof c.getSectionsToRender === 'function') {
      fd.append('sections', c.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
    }
    if (typeof c.setActiveElement === 'function') c.setActiveElement(btn || document.activeElement);
    if (btn) btn.setAttribute('aria-busy', 'true');

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (x) { return x.json(); })
      .then(function (res) {
        if (res.status) { window.location = cartUrl; return; }
        if (c.classList.contains('is-empty')) c.classList.remove('is-empty');
        c.renderContents(res);
      })
      .catch(function () { window.location = cartUrl; })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });

    return true;
  }

  if (form) {
    form.addEventListener('submit', function (ev) {
      if (aggiungi(cta)) ev.preventDefault();
    });
  }

  /* Barra sticky: aggiunge davvero al carrello */
  var bcta = barra ? barra.querySelector('.btn') : null;
  if (bcta && cta) {
    bcta.addEventListener('click', function (ev) {
      if (aggiungi(bcta)) ev.preventDefault();
    });
  }

  /* La barra compare solo DOPO aver superato il pulsante principale,
     non quando questo e ancora sotto lo schermo. */
  var oss = cta || $('.btn--full');
  if (barra && oss && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      var en = e[0];
      barra.classList.toggle('vis', !en.isIntersecting && en.boundingClientRect.top < 0);
    }, { rootMargin: '-90px 0px 0px 0px' }).observe(oss);
  }
})();
